var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgSuccess = function SvgSuccess(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.32322 9.17681L5.5 9.35358L5.67678 9.17681L13.1768 1.67681L13.3536 1.50003L13.1768 1.32326L12.4698 0.616255L12.293 0.439485L12.1162 0.616248L5.49999 7.232L1.88377 3.61624L1.70699 3.43949L1.53022 3.61625L0.823223 4.32325L0.646447 4.50003L0.823223 4.67681L5.32322 9.17681Z",
    fill: "#198038",
    stroke: "#198038",
    strokeWidth: 0.5
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgSuccess);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxNCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuMzIzMjIgOS4xNzY4MUw1LjUgOS4zNTM1OEw1LjY3Njc4IDkuMTc2ODFMMTMuMTc2OCAxLjY3NjgxTDEzLjM1MzYgMS41MDAwM0wxMy4xNzY4IDEuMzIzMjZMMTIuNDY5OCAwLjYxNjI1NUwxMi4yOTMgMC40Mzk0ODVMMTIuMTE2MiAwLjYxNjI0OEw1LjQ5OTk5IDcuMjMyTDEuODgzNzcgMy42MTYyNEwxLjcwNjk5IDMuNDM5NDlMMS41MzAyMiAzLjYxNjI1TDAuODIzMjIzIDQuMzIzMjVMMC42NDY0NDcgNC41MDAwM0wwLjgyMzIyMyA0LjY3NjgxTDUuMzIzMjIgOS4xNzY4MVoiIGZpbGw9IiMxOTgwMzgiIHN0cm9rZT0iIzE5ODAzOCIgc3Ryb2tlLXdpZHRoPSIwLjUiLz4KPC9zdmc+Cg==";